import { createCowLogger } from '@cowprotocol/common-utils'

export const logUsdPrices = createCowLogger('UsdPrices')
